import { Injectable } from '@angular/core';
import {
    HttpRequest, HttpResponse, HttpHandler, HttpEvent, HttpInterceptor, HTTP_INTERCEPTORS
} from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/delay';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/materialize';
import 'rxjs/add/operator/dematerialize';
import * as docList from '../../assets/mock-data/doc-list.json';

@Injectable()
export class FakeBackendInterceptor implements HttpInterceptor {

    private docList = docList;
    private users = [
        {
            id: 1,
            username: 'Shipper99',
            password: '1',
            firstName: 'John',
            lastName: 'Johnson'
        },
        {
            id: 2,
            username: 'Carrier99',
            password: '1',
            firstName: 'Jack',
            lastName: 'Jackson'
        }
    ];

    public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // wrap in delayed observable to simulate server api call
        return Observable.of(null).mergeMap(() => {
            if (request.url.match(/docList\//) && request.method === 'GET') {
                let docListBody = this.docList;
                let splits = request.url.split('/');
                let cmrId = splits[splits.length - 1];
                let docListRes = [];
                for (const docListItem of docListBody) {
                    if (docListItem.cmrId === cmrId) {
                        docListRes.push(docListItem);
                        return Observable.of(new HttpResponse({status: 200, body: docListRes}));
                    }
                }
                return Observable.of(new HttpResponse({status: 400}));
            } else if (request.url.endsWith('/api/authenticate') &&
                request.method === 'POST') {
                let params = JSON.parse(request.body);
                let filteredUsers = this.users.filter(user => {
                    return user.username === params.username && user.password === params.password;
                });
                if (filteredUsers.length) {
                    let user = filteredUsers[0];
                    return Observable.of(new HttpResponse({status: 200, body: user}));
                } else {
                    return Observable.of(new HttpResponse({status: 400, body: 'Username or password is incorrect'}));
                }
            }
            // pass through any requests not handled above
            return next.handle(request);
        })

        // call materialize and dematerialize to ensure delay even if an error is thrown
            .materialize()
            .delay(500)
            .dematerialize();
    }
}

/**
 * Fake backend provider for mock version. Used that in place of Http service for backend-less development.
 * @type {{provide: InjectionToken<HttpInterceptor[]>; useClass: FakeBackendInterceptor; multi: boolean}}
 */
export let fakeBackendProvider = {
    provide: HTTP_INTERCEPTORS,
    useClass: FakeBackendInterceptor,
    multi: true
};



// WEBPACK FOOTER //
// ./src/app/helpers/fake-backend.ts